/* eslint-disable react/prop-types */
import React, {useState} from 'react';

import useDebounce from "hooks/useDebounce";
import {AiOutlineSearch} from "react-icons/ai";
import TextField from '@mui/material/TextField';
import { Container } from './styles';

const SearchInput = (props) => {

    const [loading, setLoading] = useState(false)
    const [displayValue, setDisplayValue] = useState('')
    const debouncedChange = useDebounce(props.onChange, 500, setLoading);

    const handleChange = (e) => {
        setLoading(true)
        setDisplayValue(e.target.value);
        debouncedChange(e.target.value);
    }

    return (
        <Container className="input-group align-items-center mb-3 ">
             <TextField label={props.placeholder} defaultValue={displayValue} onChange={handleChange} variant="standard" className="w-100 custom-search"/>
            <span className="input-group-wl">
               {!loading ? <AiOutlineSearch size="1.3rem" /> : <span className="spinner-border spinner-border-xs" role="status"/>}
            </span>
        </Container>
    )
}

export default SearchInput
